import { render, staticRenderFns } from "./adequacy-checks-icon.vue?vue&type=template&id=25361881"
import script from "./adequacy-checks-icon.vue?vue&type=script&lang=js"
export * from "./adequacy-checks-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports